import { useUserLookup } from "~/hooks/useUsers"

export function CellUser({ userId }: { userId: string }) {
  const { getUserName, getUserImage } = useUserLookup()

  const image = getUserImage(userId)
  const name = getUserName(userId)

  return (
    <div className="flex items-center gap-2">
      {image && <img src={image} alt={name} className="h-4 w-4 rounded-full" />}
      <span>{name}</span>
    </div>
  )
}
